import { getTime } from '@yandex-int/k-common/client/api';
import { SimpleCallback } from 'platform-components';

import { SECOND, MINUTE } from './constants';

const SYNC_INTERVAL = 5 * MINUTE;
const SYNC_DRIFT = 2 * MINUTE;
const SYNC_TIMEOUT = 10 * SECOND;

const TICK_INTERVAL_MS = 100;
const MAX_TICK_DELAY = 2 * SECOND;

export default class Timer {
    private constructor() {}

    private static instance: Timer;
    private static promise: Promise<void>;

    public static getInstance = (callback?: SimpleCallback) => {
        if (!Timer.instance || Timer.instance.destroyed) {
            Timer.instance = new Timer();
            Timer.promise = Timer.instance.sync().then(callback);
        } else if (!Timer.instance.readyToSync && callback) {
            Timer.promise.then(callback);
        }

        return Timer.instance;
    };

    private readyToSync: boolean = true;
    private destroyed: boolean = false;

    private computedDate: number;
    private time: number;

    private tickIntervalDescriptor: ReturnType<typeof setInterval>;
    private syncIntervalDescriptor: ReturnType<typeof setInterval>;
    private syncTimeoutDescriptor: ReturnType<typeof setTimeout>;

    private setReadyForSync = () => {
        this.readyToSync = true;
    };

    private sync = async () => {
        let date = this.time;

        try {
            this.readyToSync = false;
            date = await getTime();

            if (this.destroyed) {
                return;
            }
        } catch (e) {
            console.error(e);
        } finally {
            this.setTimers(new Date(date).getTime());
        }
    };

    setTimers = (time: number) => {
        this.computedDate = Date.now();
        this.time = time;

        const syncDrift = Math.random() * SYNC_DRIFT;
        const syncInterval = SYNC_INTERVAL + syncDrift;

        this.tickIntervalDescriptor = setInterval(this.tick, TICK_INTERVAL_MS);
        this.syncIntervalDescriptor = setInterval(this.reset, syncInterval);
        this.syncTimeoutDescriptor = setTimeout(this.setReadyForSync, SYNC_TIMEOUT);
    };

    private reset = () => {
        this.clear();
        this.sync();
    };

    private clear = () => {
        clearInterval(this.tickIntervalDescriptor);
        clearInterval(this.syncIntervalDescriptor);
        clearTimeout(this.syncTimeoutDescriptor);
    };

    private tick = () => {
        const delta = Date.now() - this.computedDate;

        // что-то пошло не так
        if (delta > MAX_TICK_DELAY || delta < 0) {
            if (!this.readyToSync) {
                return;
            }

            this.reset();

            return;
        }

        this.time += delta;
        this.computedDate += delta;
    };

    public now = (): Date | null => {
        return this.time ? new Date(this.time) : null;
    };

    // только для тестов
    // в приложении timer должен жить вечно
    public destroy = () => {
        this.clear();
        this.destroyed = true;
    };
}
